import React from 'react';
import { Grid2, Paper, Box, Typography, alpha } from '@mui/material';
import { Groups, WarningAmber, PhotoCamera, Smartphone } from '@mui/icons-material';
import { IClassKpis } from 'services/SchoolClass/types';

interface Props {
  kpis: IClassKpis;
}

export function ClassKpiCards({ kpis }: Props) {
  const KPIS_DATA = [
    { title: "Presença Hoje", value: kpis.attendanceToday, info: "Alunos", type: "success", icon: <Groups /> },
    { title: "Atrasos Hoje", value: kpis.latesToday.toString(), info: "Registrados", type: "error", icon: <WarningAmber /> },
    { title: "Acessos Biométricos", value: kpis.facialAccessesToday.toString(), info: "Faciais", type: "default", icon: <PhotoCamera /> },
    { title: "Notificações Enviadas", value: kpis.notificationsSentToday.toString(), info: "App AlertAi", type: "default", icon: <Smartphone /> },
  ];

  return (
    <Grid2 container spacing={3}>
      {KPIS_DATA.map((kpi, idx) => (
        <Grid2 key={idx} size={{ xs: 12, sm: 6, lg: 3 }}>
          <Paper 
            elevation={0} 
            sx={{ 
              p: 2.5, borderRadius: 3, border: '1px solid', borderColor: 'divider', 
              bgcolor: 'background.paper', display: 'flex', flexDirection: 'column', 
              gap: 1, height: '100%' 
            }}
          >
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: 'text.secondary' }}>
              <Typography variant="body2" fontWeight="medium">{kpi.title}</Typography>
              <Box sx={{ color: kpi.type === 'error' ? 'error.main' : 'inherit', display: 'flex' }}>
                 {kpi.icon}
              </Box>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1, mt: 1 }}>
              <Typography variant="h4" fontWeight="bold" color="text.primary">
                {kpi.value}
              </Typography>
              <Typography 
                variant="caption" fontWeight="bold"
                sx={{ 
                  color: kpi.type === 'success' ? 'success.main' : 'text.secondary',
                  bgcolor: kpi.type === 'success' ? (theme) => alpha(theme.palette.success.main, 0.1) : 'transparent',
                  px: kpi.type === 'success' ? 1 : 0, py: kpi.type === 'success' ? 0.5 : 0, borderRadius: 1
                }}
              >
                {kpi.info}
              </Typography>
            </Box>
          </Paper>
        </Grid2>
      ))}
    </Grid2>
  );
}